module.exports = __webpack_public_path__ + "static/img/login_bg.d9a6806.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/login_bg.png
// module id = rleu
// module chunks = 36